import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { useDrawerType } from '../../Hooks/useDrawerType'
import { useMemo } from 'react'

export const EbolDrawerTitle = () => {
  const drawerType = useDrawerType()
  const title = useMemo(() => {
    if (drawerType === 'viewingAll') return "Review unmatched eBOL's"
    if (drawerType === 'match') return 'Manually override current BOL data with an eBOL'
    if (drawerType === 'unmatch') return 'Review or unmatch eBOL from the selected BOL'
    return ''
  }, [drawerType])
  return (
    <Horizontal verticalCenter style={{ flexWrap: 'wrap', columnGap: '6rem' }}>
      <Texto weight='bold' category='h5'>
        eBOL Matching
      </Texto>
      <Texto weight='bold' category='h5'>
        {title}
      </Texto>
    </Horizontal>
  )
}
